import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { jobService } from "services/job.service";

function JobVerifyOtp({
  show,
  handleClose,
  selectedJobId,
}) {

  const [error, setError] = useState(null);
  const [otp, setOtp] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleOTPChange = (e) => {
    setOtp({
      ...otp,
      [e.target.name]: e.target.value
    })
    if (e.target.nextSibling && e.target.value) {
      e.target.nextSibling.focus();
    }
  }

  const handleVerify = async () => {
    const otpData = Object.values(otp).filter(item => item);
    if (otpData.length !== 4) {
      setError("Please enter otp")
      return;
    }
    setError(null);
    const payload = {
      jobId: selectedJobId,
      otp: otpData.join(""),
    }
    try {
      setIsLoading(true);
      const response = await jobService.startJob(payload);
     
      if (response?.data?.success === false) {
        toast.warning(response?.data?.message);
    } else {
      setTimeout(() => {
        handleClose();
        toast.success('Job started successfully');
        navigate('/my-jobs');
      }, 2000)
    }
    } catch (err) {
      console.error(err?.response?.data?.message);
      setError(err?.response?.data?.message);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 2000)
    }
  }

  return (
    <>
      <Modal
        show={show}
        className="modal-common verify-otp-modal"
        onHide={handleClose}
      >
        <Modal.Body>
          <form>
            <div className="head-verify">
              <h4>Start Job Verification</h4>
              <p>
                Enter the 4 digit verification code which will be shared by the customer at
                the time of the job
              </p>
            </div>

            <div className="verification-code m-0">
              <div className="verification-code--inputs d-flex mt-4">
                <input name="otp-1" type="text" maxLength={1} onKeyUp={handleOTPChange} />
                <input name="otp-2" type="text" maxLength={1} onKeyUp={handleOTPChange} />
                <input name="otp-3" type="text" maxLength={1} onKeyUp={handleOTPChange} />
                <input name="otp-4" type="text" maxLength={1} onKeyUp={handleOTPChange} />
              </div>
            </div>
            {error && <div className="text-danger text-center">{error}</div>}

            <button
              type="button"
              className="btn d-inline-block btn-primary modal-blue-btn text-capitalize w-100 text-white"
              onClick={handleVerify}
              disabled={isLoading}
            >
              {isLoading ? 'Verifying...' : 'Verify code'}
            </button>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default JobVerifyOtp;
